import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { DivWithShadowAlternate } from '@styled';
import Tab from '../Tab';

// eslint-disable-next-line react/display-name
const Tabs = React.forwardRef(({ defaultActiveTab, children, onTabChange }, ref) => {
    const [activeTabKey, setActiveTab] = useState();

    useEffect(() => {
        if (defaultActiveTab) {
            setActiveTab(defaultActiveTab);
        }
    }, [defaultActiveTab]);

    const onClickTab = tabKey => {
        setActiveTab(tabKey);
        if (onTabChange) {
            onTabChange(tabKey);
        }
    };

    const renderTab = child => {
        const { title, tabKey } = child.props;
        if (title === null || title === '') {
            return null;
        }
        return <Tab activeTabKey={activeTabKey} title={title} key={tabKey} tabKey={tabKey} onClick={onClickTab} />;
    };

    return (
        <div ref={ref}>
            <div className="d-flex">{React.Children.map(children, renderTab)}</div>
            <DivWithShadowAlternate className="p-2rem">
                {children.map(child => {
                    if (child.props.tabKey !== activeTabKey) return null;
                    return child.props.children;
                })}
            </DivWithShadowAlternate>
        </div>
    );
});

Tabs.propTypes = {
    children: PropTypes.array,
    defaultActiveTab: PropTypes.string,
    onTabChange: PropTypes.func,
};

export default Tabs;
